<div class="column-mapping-step">
  <div class="mapping-instructions">
    <mat-icon>info</mat-icon>
    <p>Map your CSV columns to the required fields. Preview your data below to ensure correct mapping.</p>
  </div>

  <!-- Headers checkbox -->
  <div class="headers-checkbox">
    <mat-checkbox [(ngModel)]="columnMapping.hasHeaders" (ngModelChange)="onHasHeadersChange()">
      First row contains column headers
    </mat-checkbox>
  </div>

  <!-- Column mapping selectors -->
  <div class="mapping-selectors">
    <div class="selector-group">
      <label class="selector-label required">Account Number Column</label>
      <mat-select 
        [(ngModel)]="columnMapping.accountNumberColumn" 
        (ngModelChange)="onMappingChange()"
        placeholder="Select column">
        <mat-option [value]="-1">-- Select Column --</mat-option>
        <mat-option *ngFor="let col of availableColumns" [value]="col.index">
          {{ col.preview }}
        </mat-option>
      </mat-select>
    </div>

    <div class="selector-group">
      <label class="selector-label required">Amount Column</label>
      <mat-select 
        [(ngModel)]="columnMapping.amountColumn" 
        (ngModelChange)="onMappingChange()"
        placeholder="Select column">
        <mat-option [value]="-1">-- Select Column --</mat-option>
        <mat-option *ngFor="let col of availableColumns" [value]="col.index">
          {{ col.preview }}
        </mat-option>
      </mat-select>
    </div>

    <div class="selector-group">
      <label class="selector-label">Invoice Number Column (Optional mapping)</label>
      <mat-select 
        [(ngModel)]="columnMapping.invoiceNumberColumn" 
        (ngModelChange)="onMappingChange()"
        placeholder="Select column">
        <mat-option [value]="undefined">-- None --</mat-option>
        <mat-option *ngFor="let col of availableColumns" [value]="col.index">
          {{ col.preview }}
        </mat-option>
      </mat-select>
      <p class="selector-hint">
        <mat-icon>lightbulb</mat-icon>
        Invoice numbers can contain commas and will capture all text from this column onwards.
      </p>
      <p class="selector-hint warning-hint">
        <mat-icon>warning</mat-icon>
        Every payment needs a non-blank invoice number. Rows whose invoice cell is blank — or rows that don't map this column at all — must have an invoice filled in on the Review step before they can be processed.
      </p>
    </div>
  </div>

  <!-- Validation summary -->
  <div class="validation-summary" [class.valid]="isValidMapping()" [class.invalid]="!isValidMapping()">
    <mat-icon>{{ isValidMapping() ? 'check_circle' : 'error' }}</mat-icon>
    <span *ngIf="isValidMapping()">Column mapping is valid. Click "Next" to continue.</span>
    <span *ngIf="!isValidMapping()">Please select Account Number and Amount columns to continue.</span>
  </div>

  <!-- CSV Preview -->
  <div class="csv-preview">
    <h4>Data Preview</h4>
    <div class="preview-table-container">
      <table class="preview-table">
        <thead>
          <tr>
            <th *ngFor="let col of availableColumns; let i = index" 
                [class.mapped-account]="i === columnMapping.accountNumberColumn"
                [class.mapped-amount]="i === columnMapping.amountColumn"
                [class.mapped-invoice]="i === columnMapping.invoiceNumberColumn">
              {{ getPreviewHeader(i) }}
              <span class="mapping-label" *ngIf="i === columnMapping.accountNumberColumn">Account #</span>
              <span class="mapping-label" *ngIf="i === columnMapping.amountColumn">Amount</span>
              <span class="mapping-label" *ngIf="i === columnMapping.invoiceNumberColumn">Invoice #</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of previewRows">
            <td *ngFor="let cell of row; let i = index"
                [class.mapped-account]="i === columnMapping.accountNumberColumn"
                [class.mapped-amount]="i === columnMapping.amountColumn"
                [class.mapped-invoice]="i === columnMapping.invoiceNumberColumn">
              {{ cell }}
            </td>
          </tr>
          <tr *ngIf="previewRows.length === 0">
            <td [attr.colspan]="availableColumns.length" class="no-data">No preview data available</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="preview-note">
      <mat-icon>visibility</mat-icon>
      Showing first {{ previewRows.length }} data rows
    </p>
  </div>
</div>





